import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { fiDebounce } from '@fi-shared/utils';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[fiBecomeVisibleElements]',
    exportAs: 'fiBecomeVisibleElements',
    standalone: false,
})
export class BecomeVisibleElementsDirective implements AfterViewInit, OnDestroy {
    @Input('fiBecomeVisibleElements') elementsSelector: string;

    private data: {
        element: HTMLElement;
        onBecomeVisibleCallback: () => void;
    }[] = [];

    constructor(private elementRef: ElementRef<HTMLElement>) {}

    ngAfterViewInit(): void {
        const scrollableElements: HTMLElement[] = [];
        // get all scrollable parents
        let currentElement = this.elementRef.nativeElement;
        while (currentElement) {
            if (currentElement.hasAttribute('fi-scroll-root')) {
                scrollableElements.push(currentElement);
            }
            currentElement = currentElement.parentElement;
        }

        scrollableElements.forEach((scrollableElement) => {
            fromEvent(scrollableElement, 'scroll')
                .pipe(takeUntil(this.ngOnDestroy$))
                .subscribe(() => {
                    this.checkElementsVisibilityDebounced();
                });
        });
    }

    addElementToCheckVisibilityQueue(element: HTMLElement, onBecomeVisibleCallback: () => void) {
        this.data.push({
            element: element,
            onBecomeVisibleCallback: onBecomeVisibleCallback,
        });
        this.checkElementsVisibilityDebounced();
    }

    private checkElementsVisibilityDebounced = fiDebounce(() => this.checkElementsVisibility(), 200);

    checkElementsVisibility() {
        const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        const dataToCheck = this.data.slice(0);
        dataToCheck.forEach((item) => {
            const rect = item.element.getBoundingClientRect();
            if (rect.top <= viewHeight) {
                item.onBecomeVisibleCallback();
                this.data.splice(this.data.indexOf(item), 1);
                //this.checkElementsVisibilityDebounced();
            }
        });
    }

    removeElementFromCheckVisibilityQueue(element: HTMLElement) {
        this.data = this.data.filter((item) => item.element !== element);
        this.checkElementsVisibilityDebounced();
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
